module.exports = __webpack_public_path__ + "school/img/zhongxueJc.010b2870.jpg";